import React from 'react';
import { Table, Tag, Typography, Alert } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { MigrationConfigSummary } from '../types';
import { CONVERSION_LABELS } from '../constants';
import { ConversionType } from '../types';

const { Text } = Typography;

interface Props {
  conversionType: ConversionType;
  configSummary:  MigrationConfigSummary[];
  submitting:     boolean;
}

const columns: ColumnsType<MigrationConfigSummary> = [
  {
    title:     'Source SKU',
    dataIndex: 'sourceSkuName',
    key:       'sourceSkuName',
    ellipsis:  true,
  },
  {
    title:     'New SKU Name',
    dataIndex: 'targetSkuName',
    key:       'targetSkuName',
    ellipsis:  true,
    render:    (name: string) => <Text strong>{name}</Text>,
  },
  {
    title:  'Buying Model',
    key:    'targetBuyingModel',
    width:  120,
    render: (_: unknown, r: MigrationConfigSummary) => {
      const m = (r.targetBuyingModel || '').toUpperCase();
      return <Tag color={m === 'EA' ? 'blue' : m === 'ALC' ? 'orange' : 'default'}>{m || '—'}</Tag>;
    },
  },
  {
    title:  'PSC Rows',
    key:    'psc',
    width:  90,
    align:  'center' as const,
    render: (_: unknown, r: MigrationConfigSummary) => r.productSkuConfigCount,
  },
  {
    title:  'Entitlements',
    key:    'psce',
    width:  110,
    align:  'center' as const,
    render: (_: unknown, r: MigrationConfigSummary) => r.productSkuConfigEntitlementCount,
  },
  {
    title:  'Org Ent.',
    key:    'soec',
    width:  90,
    align:  'center' as const,
    render: (_: unknown, r: MigrationConfigSummary) => r.skuOrgEntitlementConfigCount,
  },
];

const StepReview: React.FC<Props> = ({ conversionType, configSummary, submitting }) => (
  <div>
    <Alert
      type="info"
      showIcon
      message={`You are about to create ${configSummary.length} new SKU(s) via "${CONVERSION_LABELS[conversionType]}" migration.`}
      description="Review the table below. Click 'Convert & Create' to proceed. This action cannot be undone."
      style={{ marginBottom: 16 }}
    />

    <Table<MigrationConfigSummary>
      rowKey="sourceSkuId"
      columns={columns}
      dataSource={configSummary}
      pagination={false}
      size="small"
      loading={submitting}
      scroll={{ y: 400 }}
    />
  </div>
);

export default StepReview;
